import * as angular from 'angular';
import * as _ from 'lodash';
import {ConfigController, EquipmentDataPoint} from "./config.base";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import EquipmentServiceName, {EquipmentService} from "../../services/equipment/equipment.service";
import NotifyServiceName, {NotifyService} from "../../services/notify/notify.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import {PlantLocation} from "../../services/locations/locations.service";
import {apsCommands} from "../../shared/dto/aps.commands";
import template from './updateConfig.tpl.html';
import DataPointsSelector from './dataPointsSelector.directive';
import ConfigSelector from './configSelector.directive';

let requires = [EquipmentServiceName, NotifyServiceName, LoaderServiceName, DataPointsSelector, ConfigSelector];

interface UpdateConfigController extends ConfigController {
  save(): void;
  cancel(): void;
  ipAddressPattern: RegExp;
}

export interface UpdateConfigParams {
  instance: apsViewModels.EquipmentDetail;
  plantId: string;
  locations: PlantLocation[];
  allEquipment: apsViewModels.EquipmentDetail[];
  isNotProd: boolean;
  ipAddressPattern: RegExp;
}

export function openUpdateConfig(data: UpdateConfigParams,
                                 $modal: mm.foundation.modal): angular.IPromise<any> {
  return $modal.open({
    template: template,
    controller: 'UpdateConfigCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class UpdateConfigCtrl implements UpdateConfigController {
  instance: apsViewModels.EquipmentDetail;
  config: any;
  form: angular.IFormController;
  location: PlantLocation;
  locations: PlantLocation[];
  dataPoints: EquipmentDataPoint[];
  allEquipment: apsViewModels.EquipmentDetail[];
  isNotProd: boolean;
  ipAddressPattern: RegExp;

  private plantId: string;
  private $modalInstance: mm.foundation.modalInstance;
  private equipmentService: EquipmentService;
  private notifyService: NotifyService;
  private loaderService: LoaderService;

  constructor(
    $modalInstance: mm.foundation.modalInstance,
    equipmentService: EquipmentService,
    data: UpdateConfigParams,
    notifyService: NotifyService,
    loaderService: LoaderService
  ) {
    this.$modalInstance = $modalInstance;
    this.equipmentService = equipmentService;
    this.notifyService = notifyService;
    this.loaderService = loaderService;

    this.instance = data.instance;
    this.plantId = data.plantId;
    this.allEquipment = data.allEquipment;
    this.isNotProd = data.isNotProd;
    this.ipAddressPattern = data.ipAddressPattern;
    this.config = JSON.parse(data.instance.config);
    this.locations = data.locations;
    this.location = _.find(data.locations, {
      locationType: data.instance.plantLocationLocationType,
      id: data.instance.plantLocationLocationTypeId
    });
    this.dataPoints = JSON.parse(JSON.stringify(data.instance.dataPoints));
    _.forEach(this.dataPoints, (dp: EquipmentDataPoint) => {
      dp.jsonConfig = JSON.parse(dp.config);
    });
  }

  save(): void {
    if (this.form.$invalid) {
      return;
    }

    _.forEach(this.dataPoints, (dp: EquipmentDataPoint) => {
      dp.config = JSON.stringify(dp.jsonConfig);
    });

    let command: apsCommands.UpdateEquipmentConfig = {
      id: this.instance.id,
      plantId: this.plantId,
      config: JSON.stringify(this.config),
      dataPoints: JSON.parse(JSON.stringify(this.dataPoints))
    };

    _.forEach(command.dataPoints, (dp: any) => {
      dp.jsonConfig = undefined;
    });

    this.loaderService.loadingPromise(this.equipmentService.updateConfig(command)
      .then(() => {
        this.instance.config = command.config;
        this.instance.dataPoints = <apsViewModels.DataPointDetail[]>command.dataPoints;
        _.forEach(this.instance.dataPoints, (dp: apsViewModels.DataPointDetail) => {
          dp.plantId = this.plantId;
        });
        this.$modalInstance.close();
      }, this.notifyService.handleApiErrors)
    );
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.updateConfig', requires)
  .controller('UpdateConfigCtrl', UpdateConfigCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/equipment/updateConfig.controller.ts